<template>
    <div class="menu_section filters_menu ">
      <span class="menu_overlay" @click="toggleFilterMenu"></span>
      <div class="filters_menu_cnt"> 
        <div @click="toggleFilterMenu" class="filter-btn" :style="{ 'min-width': $store.state.common.totalCount ? '140px' : '' }">
            <img src="@/assets/images/main/icon-filter.svg" /> Filters <span v-if="$store.state.common.totalCount">({{ $store.state.common.totalCount }})</span>
        </div>
        <slot></slot> 
      </div>
    </div>
  </template>
 
 <script>
 export default {
   data() {
     return {
       isFilterMenuOpen: false,
     };
   },
   methods: {
     toggleFilterMenu() {
       if ( document.body.classList.contains("scroll-hidden")) {
         document.body.classList.remove('scroll-hidden');
         this.$emit('removeUnappliedFilters')
       } else {
         document.body.classList.add('scroll-hidden');
       }
     },
   },
 };
 </script>